import * as Diagram from "../../../../components/diagram";

export const WeakVisitList = {
  label: "衰弱訪視清冊",
  key: "WeakVisitList",
  path: "ElderlyHealth/WeakVisitList",
  api: "TCS_V_FrailtyVisitList",
  render: (options) => <Diagram.ElderlyHealth.WeakVisitList {...options} />,
  isRaw: true,
  isPage: true,
  filterColumns: [
    { key: "鄉鎮", label: "照護鄉鎮", type: "string" },
    { key: "案件狀態", type: "string" },
  ],
  columns: [
    {
      key: "身分證號",
      field: "身分證號",
      header: "身分證號",
    },
    {
      key: "個案名字",
      field: "個案名字",
      header: "個案名字",
    },
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "照護鄉鎮",
    },
    {
      key: "居住地址",
      field: "居住地址",
      header: "居住地址",
    },
    {
      key: "案件狀態",
      field: "案件狀態",
      header: "案件狀態",
    },
    {
      key: "訪視類別",
      field: "訪視類別",
      header: "訪視類別",
    },
    {
      key: "居住環境",
      field: "居住環境",
      header: "居住環境",
    },
  ],
};
